// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2rzYP","notes":"Notes_notes__3owLq"};